module.exports = __webpack_public_path__ + "static/img/10.4b7b4e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/sp/10.png
// module id = M1YI
// module chunks = 0